import React from "react";
import { Mouse } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function SeenWhereLinkopingMoves() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="27654" id="upptäck-friheten-på-din-nästa-vandring" className="dark relative h-screen w-full overflow-hidden text-foreground">
      {}
      <div className="absolute inset-0 z-0">
        <video autoPlay muted loop playsInline poster="/img/amalfi_coast_dawn.jpg" className="h-full w-full object-cover">
          <source src="/videos/hiking_amalfi.mp4" type="video/mp4" />
          {}
          <img src="/img/amalfi_coast_dawn.jpg" alt="Vandrare vid Amalfikusten i soluppgången" className="h-full w-full object-cover" />
        </video>
        {}
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1609312/img/image_115nnrsh.png)] bg-cover bg-center opacity-40" />
      </div>

      {}
      <div className="relative z-10 flex h-full flex-col items-center justify-center px-4 text-center">
        <div ref={ref} className={`transition-all duration-1000 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
          {}
          <h1 className="mb-6 flex flex-col items-center justify-center font-black tracking-tighter leading-[0.9]">
            <span className="text-6xl sm:text-8xl md:text-9xl lg:text-[10rem] text-white drop-shadow-2xl">
              UPPTÄCK
            </span>
            <span className="text-6xl sm:text-8xl md:text-9xl lg:text-[10rem] text-transparent [-webkit-text-stroke:2px_var(--color-accent)] md:[-webkit-text-stroke:3px_var(--color-accent)] drop-shadow-lg">
              FRIHETEN
            </span>
          </h1>

          {}
          <p className="mx-auto mb-10 max-w-2xl text-lg font-medium text-white/90 md:text-xl lg:text-2xl">
            Utforska Europas vackraste leder med våra digitala guider. Spara tusenlappar 
            och planera ditt nästa äventyr på bara några minuter.
          </p>

          {}
          <Button asChild size="lg" className="h-14 rounded-full bg-accent px-10 text-lg font-bold text-accent-foreground hover:bg-accent/90 shadow-[0_0_20px_rgba(249,115,22,0.4)] transition-transform hover:scale-105">
            <Link to="#">Utforska guider</Link>
          </Button>
        </div>
      </div>

      {}
      <div className="absolute bottom-10 left-1/2 z-10 -translate-x-1/2 animate-bounce text-white/80">
        <div className="flex flex-col items-center gap-2">
          <span className="text-xs font-medium uppercase tracking-widest text-white/60">
            Scrolla
          </span>
          <Mouse className="h-8 w-8" />
        </div>
      </div>
    </section>;
}